/* vitrina.js — interacoes da VITRINA (vanilla, sem dependencias)
   - aside colapsavel com persistencia (localStorage)
   - carrosseis com setas
   - add-to-cart AJAX dos cards e do pack La Coleccion
   - atalho "/" foca a busca; gaveta movil
*/
(function () {
  var html = document.documentElement;

  // liga animacoes so depois do primeiro paint (evita "pulo" no load)
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { html.classList.add('vt-anim'); });
  });

  // ---- aside colapsavel ----
  document.querySelectorAll('[data-vt-alternar]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var min = html.classList.toggle('vt-min');
      try { localStorage.setItem('vt-aside', min ? 'min' : 'max'); } catch (e) {}
    });
  });

  // ---- carrosseis ----
  document.querySelectorAll('[data-vt-carrusel]').forEach(function (sec) {
    var pista = sec.querySelector('[data-vt-pista]');
    if (!pista) return;
    function paso() {
      var card = pista.firstElementChild;
      return card ? (card.getBoundingClientRect().width + 18) * 2 : 400;
    }
    var prev = sec.querySelector('[data-vt-prev]');
    var next = sec.querySelector('[data-vt-next]');
    if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
  });

  // ---- helpers de cesta ----
  function actualizarContador() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }
  function aviso(msg) {
    if (window.mostrarAlerta) { window.mostrarAlerta(msg); return; }
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText =
      'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:99;' +
      'background:#10201A;color:#EFE9DC;border:1px solid rgba(217,164,65,.5);' +
      'padding:12px 22px;border-radius:999px;font-size:.85rem;box-shadow:0 12px 30px -8px rgba(0,0,0,.6)';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2600);
  }
  function anadir(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  // ---- add-to-cart dos cards ----
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-vt-anadir]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    btn.disabled = true;
    anadir([{ id: id, quantity: 1 }])
      .then(function () {
        btn.classList.add('listo');
        var rot = btn.querySelector('span');
        if (rot) rot.textContent = 'En la cesta ✓';
        actualizarContador();
        document.dispatchEvent(new CustomEvent('vt:anadido'));
      })
      .catch(function () { aviso('No se pudo añadir. Inténtalo de nuevo.'); })
      .finally(function () { btn.disabled = false; });
  });

  // ---- pack La Coleccion (varios ids de uma vez) ----
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-vt-combo]');
    if (!btn) return;
    var ids = btn
      .getAttribute('data-vt-combo')
      .split(',')
      .filter(Boolean)
      .map(function (s) { return { id: parseInt(s, 10), quantity: 1 }; });
    if (!ids.length) return;
    btn.disabled = true;
    var rot = btn.querySelector('span');
    if (rot) rot.textContent = 'Añadiendo...';
    anadir(ids)
      .then(function () {
        if (rot) rot.textContent = 'La Colección en la cesta ✓';
        actualizarContador();
        document.dispatchEvent(new CustomEvent('vt:anadido'));
      })
      .catch(function () {
        if (rot) rot.textContent = 'Añadir La Colección a la cesta';
        aviso('No se pudo añadir el pack. Inténtalo de nuevo.');
      })
      .finally(function () { btn.disabled = false; });
  });

  // ---- atalho "/" para a busca ----
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== '/' || ev.ctrlKey || ev.metaKey || ev.altKey) return;
    var alvo = ev.target;
    if (alvo && (alvo.tagName === 'INPUT' || alvo.tagName === 'TEXTAREA' || alvo.isContentEditable)) return;
    var campo = document.querySelector('[data-vt-busca]');
    if (campo) { ev.preventDefault(); campo.focus(); }
  });

  // ---- gaveta movil ----
  var gaveta = document.querySelector('[data-vt-gaveta]');
  if (gaveta) {
    document.querySelectorAll('[data-vt-gaveta-abrir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gaveta.hidden = false;
        requestAnimationFrame(function () { gaveta.classList.add('abierta'); });
      });
    });
    gaveta.addEventListener('click', function (ev) {
      if (ev.target === gaveta) {
        gaveta.classList.remove('abierta');
        setTimeout(function () { gaveta.hidden = true; }, 260);
      }
    });
  }
})();

/* ===== VITRINA v2: drawer de cesta, reveal-on-scroll, video ===== */
(function () {
  // ---- money EUR (formato es-ES) ----
  function dinero(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // ---- drawer ----
  var carrito = document.querySelector('[data-vt-carrito]');

  function renderCarrito(cart) {
    if (!carrito) return;
    var lista = carrito.querySelector('[data-vt-carrito-lista]');
    var num = carrito.querySelector('[data-vt-carrito-num]');
    var sub = carrito.querySelector('[data-vt-carrito-subtotal]');
    num.textContent = cart.item_count === 1 ? '1 pieza' : cart.item_count + ' piezas';
    sub.textContent = dinero(cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!cart.items.length) {
      lista.innerHTML =
        '<div class="vt-carrito__vacio">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 8h12l-1 12a2 2 0 0 1-2 1.8H9A2 2 0 0 1 7 20L6 8zM9 10V6.5a3 3 0 0 1 6 0V10"/></svg>' +
        '<p>Tu vitrina a\u00fan est\u00e1 vac\u00eda.<br>Las mejores piezas esperan sitio.</p></div>';
      return;
    }
    lista.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '';
      return (
        '<div class="vt-carrito__item" data-line-key="' + it.key + '">' +
        '<div class="vt-carrito__capa">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div>' +
        '<h3 class="vt-carrito__nombre"><a href="' + it.url + '">' + it.product_title + '</a></h3>' +
        '<div class="vt-carrito__precio">' + dinero(it.final_line_price) + '</div>' +
        '<div class="vt-carrito__qty">' +
        '<button type="button" data-vt-qty="-1" aria-label="Reducir">\u2212</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-vt-qty="1" aria-label="Aumentar">+</button>' +
        '</div></div>' +
        '<button type="button" class="vt-carrito__quitar" data-vt-quitar aria-label="Quitar pieza">Quitar</button>' +
        '</div>'
      );
    }).join('');
  }

  function cargarCarrito() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCarrito(c); return c; });
  }
  function abrirCarrito() {
    if (!carrito) return;
    cargarCarrito().then(function () {
      carrito.classList.add('abierta');
      carrito.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }
  function cerrarCarrito() {
    if (!carrito) return;
    carrito.classList.remove('abierta');
    carrito.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.vtAbrirCarrito = abrirCarrito;

  if (carrito) {
    carrito.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-vt-carrito-cerrar]')) { cerrarCarrito(); return; }
      if (ev.target.closest('[data-vt-carrito-checkout]')) { window.location.href = '/checkout'; return; }
      var qtyBtn = ev.target.closest('[data-vt-qty]');
      var quitar = ev.target.closest('[data-vt-quitar]');
      var item = ev.target.closest('[data-line-key]');
      if (!item || (!qtyBtn && !quitar)) return;
      var key = item.getAttribute('data-line-key');
      var qty = 0;
      if (qtyBtn) {
        var actual = parseInt(item.querySelector('.vt-carrito__qty span').textContent, 10);
        qty = Math.max(0, actual + parseInt(qtyBtn.getAttribute('data-vt-qty'), 10));
      }
      if (qty === 0) item.classList.add('saliendo');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (r) { return r.json(); })
        .then(renderCarrito);
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && carrito.classList.contains('abierta')) cerrarCarrito();
    });
  }

  // links de cesta abrem o drawer em vez de navegar
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('a[href$="/cart"], a.vt-cesta');
    if (!link || !carrito) return;
    ev.preventDefault();
    abrirCarrito();
  });

  // form de produto: add via AJAX + abre drawer (captura antes do carrinho.js)
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    var btn = form.querySelector('[name="add"], [type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { abrirCarrito(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  }, true);

  // cards: depois de anadir, abre o drawer
  document.addEventListener('vt:anadido', abrirCarrito);

  // ---- reveal on scroll ----
  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducir && 'IntersectionObserver' in window) {
    var candidatos = document.querySelectorAll('.vt-cab, .vt-card, .vt-catcard, .vt-edad, .vt-coleccion, .vt-listacol__item, .vt-rodape__interno');
    var porPadre = new Map();
    candidatos.forEach(function (el) {
      var padre = el.parentElement;
      var n = porPadre.get(padre) || 0;
      el.style.setProperty('--vt-d', Math.min(n, 8));
      porPadre.set(padre, n + 1);
      el.classList.add('vt-rev');
    });
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vt-vis'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.vt-rev').forEach(function (el) { io.observe(el); });
  }

  // ---- video do hero: play imediato + fade ----
  document.querySelectorAll('[data-vt-video]').forEach(function (v) {
    function listo() { v.classList.add('cargada'); }
    if (v.readyState >= 2) listo();
    v.addEventListener('loadeddata', listo);
    v.addEventListener('playing', listo);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
    });
  });
})();
